import React, { FC, useState } from 'react'

import { YMaps, Map, Placemark, YMapsApi } from 'react-yandex-maps'
import MaxWidth from '../layout/MaxWidth/MaxWidth'
import scrollToElement from 'scroll-to-element'
import PlusIcon from '../../public/static/icons/plus-big.svg'
import MinusIcon from '../../public/static/icons/minus-big.svg'
import NavIcon from '../../public/static/icons/nav.svg'
import WAIcon from '../../public/static/icons/whatsapp-white.svg'
import TGIcon from '../../public/static/icons/tg-more.svg'
import RoundBorderSvg from '../../public/static/icons/round-border.svg'

import css from './ContactsPageMain.module.scss'
import { IContacts } from '../types'
import { trackVKPurchaseGoal } from '../../lib/trackVKPurchaseGoal'

const ContactsPageMain: FC<{ contacts: IContacts }> = ({ contacts }) => {
  const [zoom, setZoom] = useState(15)
  const [center, setCenter] = useState(contacts?.coords)
  const [globalymaps, setGlobalYmaps] = useState<YMapsApi>(null)
  let mapRef

  const findUser = async () => {
    try {
      const objects = await globalymaps.geolocation.get({
        provider: 'browser',
        autoReverseGeocode: false,
      })

      await mapRef.panTo(
        [objects.geoObjects.position[0], objects.geoObjects.position[1]],
        {
          checkZoomRange: true,
        },
      )
    } catch (err) {
      console.error(err)
    }
  }
  const ZoomButtons = () => {
    return (
      <div className={css.zoom_buttons}>
        <button
          className={css.zoom_plus}
          type="button"
          onClick={() =>
            setZoom((prev) => {
              if (prev >= 20) {
                return prev
              }
              return prev + 1
            })
          }
        >
          <PlusIcon />
        </button>
        <button
          className={css.zoom_minus}
          type="button"
          onClick={() =>
            setZoom((prev) => {
              if (prev === 0) {
                return prev
              }
              return prev - 1
            })
          }
        >
          <MinusIcon />
        </button>
      </div>
    )
  }

  const NavButton = () => {
    return (
      <button type="button" className={css.nav_button} onClick={findUser}>
        <NavIcon />
      </button>
    )
  }

  return (
    <div className={css.wrapper}>
      <MaxWidth>
        <section className={css.top}>
          <h1 className={css.heading}>Офис KM COSMETICS</h1>
          <div className={css.contacts}>
            <div className={css.index}>{contacts?.index}</div>
            <address className={css.address}>{contacts?.address}</address>
            <button
              type="button"
              className={css.on_map}
              onClick={() => {
                scrollToElement('#contacts-map')
                setCenter(contacts?.coords)
              }}
            >
              Смотреть на карте
            </button>
            <a href={`tel:${contacts?.phone}`} className={css.link}>
              {contacts?.phone}
            </a>
            <a href={`mailto:${contacts?.email}`} className={css.link}>
              {contacts?.email}
            </a>

            <div className={css.info}>
              <p>Компания: ООО &quot;КМ Косметикс&quot;</p>
              <p>ИНН: 7455022184</p>
              <p>ОГРН: 1157456005046</p>
              <p>
                Юр.адрес: 195220, Россия, г. Санкт-Петербург, Кушелевская
                дорога, д. 5, корп. 3, лит А, кв. 63
              </p>
            </div>
          </div>

          <div className={css.working_hours__wrapper}>
            <p className={css.messengers__heading}>
              связаться с&nbsp;консультантом
            </p>
            <div className={css.messengers}>
              {contacts?.tg && (
                <a
                  onClick={() => {
                    trackVKPurchaseGoal('contact')
                  }}
                  className={css.messengers__link}
                  href={contacts?.tg}
                  target="_blank"
                  rel="noreferrer"
                >
                  <RoundBorderSvg className={css.messengers__border} />
                  <TGIcon />
                </a>
              )}
              {contacts?.wa && (
                <a
                  onClick={() => {
                    trackVKPurchaseGoal('contact')
                  }}
                  className={css.messengers__link}
                  href={`https://wa.me/${contacts.wa}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <RoundBorderSvg className={css.messengers__border} />
                  <WAIcon />
                </a>
              )}
            </div>
            <dl className={css.working_hours}>
              <dt className={css.heading}>Часы работы</dt>
              <dd className={css.sheldue}>
                {contacts?.workHours?.map((hour, index) => (
                  <div className={css.line} key={`working-hour-${index}`}>
                    <span className={css.day}>{hour.day}</span>
                    <span className={css.hours}>{hour.hours}</span>
                  </div>
                ))}
              </dd>
            </dl>
          </div>
        </section>
      </MaxWidth>

      <section className={css.map} id="contacts-map">
        <YMaps>
          <Map
            width="100%"
            height={643}
            state={{
              center,
              zoom,
              behaviors: ['drag', 'multiTouch'],
            }}
            onLoad={(ymaps) => setGlobalYmaps(ymaps)}
            modules={['geolocation']}
            instanceRef={(ref) => (mapRef = ref)}
          >
            <Placemark
              geometry={center}
              options={{
                iconLayout: 'default#image',
                iconImageHref: '/static/icons/placemark-ymap.svg',
              }}
            />
          </Map>
        </YMaps>
        <ZoomButtons />
        <NavButton />
      </section>
    </div>
  )
}

export default ContactsPageMain
